export const urls = {
  setInvestmentAmount: ({ amount }) =>
    `/api/v1/pro/investment-amt?amount=${amount}`,
  getTrueoneCredits: ({ code, amount }) =>
    `/api/v1/${code}/credits?amount=${amount}`,
};
